import axios from "axios";
import Vue from "vue";

export const state = {
  currentUser: JSON.parse(window.localStorage.getItem("authUser")),
  logging: false,
  authError: false,
  loggingMessage: "",
  resetMessage: "",
  resetStatus: false,
  permissions: [],
  audits: [],
  rolePermissions: [],
  userResetDetails: {},
  tokenValidation: {},
  sentToken: false,
  resetProcess: false,
};

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.currentUser;
  },
  getLogging(state) {
    return state.logging;
  },
  getAuthError(state) {
    return state.authError;
  },
  getLoggingMessage(state) {
    return state.loggingMessage;
  },
  getResetMessage(state) {
    return state.resetMessage;
  },
  getResetStatus(state) {
    return state.resetStatus;
  },
  getUserResetDetails(state) {
    return state.userResetDetails;
  },
  getCurrentUser(state) {
    return state.currentUser;
  },
  getPermissions(state) {
    return state.permissions;
  },
  getSentToken(state) {
    return state.sentToken;
  },
  getResetProcess(state) {
    return state.resetProcess;
  },
  getTokenValidation(state) {
    return state.tokenValidation;
  },
  RolePermissions: (state) => state.rolePermissions,
};

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue;
    saveState("authUser", newValue);
  },
  SET_LOGING_STATUS(state, newVal) {
    state.logging = newVal;
  },
  SET_AUTH_ERROR(state, newVal) {
    state.authError = newVal;
  },
  SET_LOGING_MESSAGE(state, newVal) {
    state.loggingMessage = newVal;
  },
  SET_RESET_MESSAGE(state, newVal) {
    state.resetMessage = newVal;
  },
  SET_RESETPROCESS_STATUS(state, newVal) {
    state.resetProcess = newVal;
  },
  SET_PERMISSIONS(state, newVal) {
    state.permissions = newVal;
  },
  SET_ROLE_PERMISSIONS(state, newVal) {
    state.rolePermissions = newVal;
  },
  SET_USER_DETAILS(state, newVal) {
    state.userResetDetails = newVal;
  },
  SET_TOKEN_VALIDATION(state, newVal) {
    state.tokenValidation = newVal;
  },
  SET_TOKEN_SENT(state, newVal) {
    state.sentToken = newVal;
  },
  SET_RESET_STATUS(state, newVal) {
    state.resetStatus = newVal;
  },
  SET_AUDITS(state, newVal) {
    state.audits = newVal;
  },
  pushNotification(state, payload) {
    Vue.notify({
      type: payload.type,
      group: "foo",
      title: payload.title,
      text: payload.message,
      position: "bottom right",
      duration: 10000,
      speed: 500,
    });
  },
};

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ dispatch }) {
    dispatch("validate");
    dispatch("createInitialData");
  },

  // Logs in the current user.
  logIn({ commit, dispatch }, payload) {
    commit("SET_LOGING_STATUS", true);
    axios
      .post("login", payload)
      .then((response) => {
        //dispatch initial data request
        dispatch("createInitialData");
        //check if the response was of success.
        if (response.data.status == 200) {
          commit("SET_CURRENT_USER", response.data);
          //store user in browser sessionStorage.
          sessionStorage.setItem("authUser", JSON.stringify(response.user));

          // commit('SET_LOGING_MESSAGE', "Successfull, Please wait...");
          // window.location.reload();

          commit("SET_LOGING_MESSAGE", "Successfull, Please wait...");
          window.location = "/";
        } else {
          commit("SET_AUTH_ERROR", true);
          commit("SET_LOGING_MESSAGE", response.data.msg);
        }

        //exiting logging status
        commit("SET_LOGING_STATUS", false);
      })
      .catch(() => {
        commit("SET_LOGING_STATUS", false);
        commit(
          "SET_LOGING_MESSAGE",
          "An Error Occurred, Incorrect Credentials"
        );
        commit("SET_AUTH_ERROR", true);
      });
  },

  createInitialData({ commit }) {
    axios
      .get("initialData")
      .then(() => {
        //any response.
        console.log("success");
      })
      .catch(() => {
        console.log("error Occurred");
        commit("SET_LOGING_MESSAGE", "An Error Occurred, Details Not Added");
        commit("SET_AUTH_ERROR", true);
      });
  },

  // Logs out the current user.
  logOut({ commit, dispatch }) {
    commit("SET_LOGING_STATUS", true);
    axios
      .get("logout-user")
      .then(() => {
        //clear browser storage
        sessionStorage.removeItem("authUser");
        localStorage.removeItem("authUser");
        dispatch("validate");
        //exiting logging status
        commit("SET_LOGING_STATUS", false);
        window.location.reload();
      })
      .catch(() => {
        commit("SET_LOGING_MESSAGE", "An Error Occurred While Logging Out");
        commit("SET_LOGING_STATUS", false);
        //clear browser storage
        sessionStorage.removeItem("authUser");
        localStorage.removeItem("authUser");
        window.location.reload();
      });
  },
  editUser({ commit }, payload) {
    axios
      .post("edit/user", payload)
      .then(() => {
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Profile updated Successfully",
        };
        commit("pushNotification", message);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "Failed to update Profile",
        };
        commit("pushNotification", message);
      });
  },

  changePassword({ commit }, payload) {
    axios
      .post("change/password", payload)
      .then((res) => {
        console.log(res.data.status);
        if (res.data.status == 200) {
          const message = {
            type: "success",
            title: "<b>Success Notifications</b>",
            message: "Password changed Successfully",
          };
          commit("pushNotification", message);
        } else {
          const message = {
            type: "error",
            title: "<b>Error Notifications</b>",
            message: "New and old passwords do not match",
          };
          commit("pushNotification", message);
        }
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "Failed to change password",
        };
        commit("pushNotification", message);
      });
  },

  // validating username for password reset
  // eslint-disable-next-line no-unused-vars
  validateUsername({ commit, dispatch }, payload) {
    commit("SET_RESET_STATUS", true);
    axios
      .post("users/validate_username", payload)
      .then((response) => {
        commit("SET_USER_DETAILS", response.data);
        commit("SET_RESET_STATUS", false);
      })
      .catch(() => {
        commit("SET_RESET_MESSAGE", "User Details Not Found");
        commit("SET_RESET_STATUS", false);
      });
  },

  // validating token for password reset
  // eslint-disable-next-line no-unused-vars
  validateSubmitedToken({ commit }, payload) {
    commit("SET_RESET_STATUS", true);
    axios
      .post("users/validate_token", payload)
      .then((response) => {
        commit("SET_TOKEN_VALIDATION", response.data);
        commit("SET_RESET_STATUS", false);
      })
      .catch(() => {
        commit("SET_RESET_MESSAGE", "Invalid Token");
        commit("SET_RESET_STATUS", false);
      });
  },

  //sending reset password token
  submitToken({ commit }, payload) {
    commit("SET_RESET_STATUS", true);
    axios
      .post("users/send_token", payload)
      .then(() => {
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Token sent successfully",
        };
        commit("pushNotification", message);
        commit(
          "SET_TOKEN_SENT",
          Math.random()
            .toString(36)
            .substr(2)
        );
        commit("SET_RESET_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Success Notifications</b>",
          message: "An Error Occured when Sending Token",
        };
        commit("pushNotification", message);
        commit("SET_RESET_STATUS", false);
      });
  },

  //sending reset password token
  submitPasswordReset({ commit }, payload) {
    commit("SET_RESET_STATUS", true);
    axios
      .post("users/reset_password", payload)
      .then(() => {
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Password Reset Successfully",
        };
        commit("pushNotification", message);
        commit("SET_RESETPROCESS_STATUS", true);
        commit("SET_RESET_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Success Notifications</b>",
          message: "An Error Occured when Resetting Password",
        };
        commit("pushNotification", message);
        commit("SET_RESET_STATUS", false);
      });
  },

  // register the user
  // eslint-disable-next-line no-unused-vars
  // resetPassword({ commit, dispatch }, payload) {
  //     commit('SET_RESET_STATUS', true)
  //     axios.post('resetPassword', payload).then(() => {
  //         // commit('SET_RESET_MESSAGE', "An Error Occurred While Logging Out");
  //         commit('SET_RESET_STATUS', false);
  //         //logout User to login again
  //         setTimeout(() => {
  //             dispatch('logOut');
  //         }, 1500);
  //     }).catch(() => {
  //         commit('SET_RESET_MESSAGE', "An Error Occurred While Logging Out");
  //         commit('SET_RESET_STATUS', false);
  //     });
  // },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  // eslint-disable-next-line no-unused-vars
  validate({ commit, state }) {
    if (!state.currentUser) return Promise.resolve(null);
    return state.currentUser;
  },

  //permissions actions
  submitPermissionsAction({ commit }, payload) {
    axios
      .post("submit/permissions", payload)
      .then(() => {
        commit("SET_RESET_STATUS", false);
      })
      .catch(() => {
        commit("SET_RESET_MESSAGE", "An Error Occurred While Logging Out");
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Logging Out",
        };
        commit("pushNotification", message);
        commit("SET_RESET_STATUS", false);
      });
  },
  //retrieving permissions
  fetchPermissions({ commit }, payload) {
    axios
      .post("permission/current", payload)
      .then(() => {
        commit("SET_RESET_STATUS", false);
      })
      .catch(() => {
        commit("SET_RESET_MESSAGE", "An Error Occurred While Logging Out");
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Logging Out",
        };
        commit("pushNotification", message);
        commit("SET_RESET_STATUS", false);
      });
  },
  //retrieving role permissions
  fetchRolePermissions({ commit }, payload) {
    axios
      .post("permission/role", payload)
      .then((response) => {
        commit("SET_RESET_STATUS", false);
        commit("SET_ROLE_PERMISSIONS", response.data.data);
        console.log(response.data.data);
      })
      .catch(() => {
        commit("SET_RESET_MESSAGE", "An Error Occurred While Logging Out");
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Logging Out",
        };
        commit("pushNotification", message);
        commit("SET_RESET_STATUS", false);
      });
  },
  fetchAudits({ commit }, payload) {
    axios
      .post("user/audits", payload)
      .then((res) => {
        commit("SET_RESET_STATUS", false);
        commit("SET_AUDITS", res.data);
      })
      .catch(() => {
        commit("SET_RESET_STATUS", false);
      });
  },
};

// ===
// Private helpers
// ===

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state));
}
